/*
  De tabbladen boven het collectieraster.

  Alle panelen staan in de pagina; een klik wisselt welke zichtbaar is. Er wordt
  dus niets nagehaald: wisselen gaat zonder wachten en zonder netwerk.

  Zonder JavaScript blijft het eerste tabblad staan. Dat is een volledige
  collectie met een link naar de rest, dus geen doodlopende pagina.
*/
(function () {
  'use strict';

  function start(sectie) {
    var tabs = sectie.querySelectorAll('[data-coltab]');
    var panelen = sectie.querySelectorAll('[data-colpaneel]');
    if (tabs.length < 2 || panelen.length < 2) return;

    /*
      Secties elders op de pagina die bij een tabblad horen. Ze dragen zelf de
      sleutel; wij verbergen de omhulling die Shopify eromheen zet, want dat is
      het element dat ruimte inneemt.
    */
    function gekoppeld() {
      var uit = [];
      var vlakken = document.querySelectorAll('[data-tabgroep]');
      for (var i = 0; i < vlakken.length; i++) {
        var waarde = (vlakken[i].getAttribute('data-tabgroep') || '').trim().toLowerCase();
        if (!waarde) continue;
        uit.push({ sleutel: waarde, vlak: vlakken[i].closest('.shopify-section') || vlakken[i] });
      }
      return uit;
    }

    function toon(sleutel) {
      var eigen = null;

      for (var i = 0; i < panelen.length; i++) {
        var raak = panelen[i].getAttribute('data-colpaneel') === sleutel;
        panelen[i].hidden = !raak;
      }
      for (var j = 0; j < tabs.length; j++) {
        var aan = tabs[j].getAttribute('data-coltab') === sleutel;
        tabs[j].classList.toggle('is-actief', aan);
        tabs[j].setAttribute('aria-selected', aan ? 'true' : 'false');
        if (aan) eigen = (tabs[j].getAttribute('data-sleutel') || '').trim().toLowerCase();
      }

      var lijst = gekoppeld();
      for (var k = 0; k < lijst.length; k++) {
        lijst[k].vlak.hidden = lijst[k].sleutel !== eigen;
      }
    }

    /* Bij het laden geldt hetzelfde: alleen de secties van het eerste tabblad. */
    var eerste = tabs[0].getAttribute('data-coltab');
    toon(eerste);

    for (var k = 0; k < tabs.length; k++) {
      (function (knop, index) {
        knop.addEventListener('click', function () {
          toon(knop.getAttribute('data-coltab'));
        });

        /* Pijltjes horen bij een tablist: links en rechts door de rij. */
        knop.addEventListener('keydown', function (e) {
          var stap = 0;
          if (e.key === 'ArrowRight') stap = 1;
          if (e.key === 'ArrowLeft') stap = -1;
          if (!stap) return;
          e.preventDefault();
          var volgende = (index + stap + tabs.length) % tabs.length;
          toon(tabs[volgende].getAttribute('data-coltab'));
          tabs[volgende].focus();
        });
      })(tabs[k], k);
    }
  }

  function alles(wortel) {
    var secties = (wortel || document).querySelectorAll('.coltabs');
    for (var i = 0; i < secties.length; i++) start(secties[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { alles(); });
  } else {
    alles();
  }

  /* In de theme editor wordt een sectie opnieuw ingevoegd zonder herladen. */
  document.addEventListener('shopify:section:load', function (e) { alles(e.target); });
})();
